'use client';

import { PropsWithChildren, useEffect, useState } from 'react';

type Props = PropsWithChildren<{
    /**
     * maxium num dot
     * @default 3
     */
    numOfDot?: number;

    className?: string;
}>;

/**
 * Custom Dot Loading
 */

export const DotLoading = ({ numOfDot = 3, children, className }: Props) => {
    const [numDot, setNumDot] = useState(numOfDot);

    useEffect(() => {
        const timer = setInterval(() => {
            setNumDot((num) => {
                if (num === numOfDot) {
                    return 0;
                }
                return num + 1;
            });
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, [numOfDot]);

    const _dotStr = Array(numDot)
        .fill(0)
        .map((_, i) => '.')
        .join(' ');

    const minLength = 8 * numOfDot; // 8px per dot

    if (children) {
        return (
            <p className={className}>
                {children}{' '}
                <span style={{ display: 'inline-block', minWidth: minLength }}>
                    {_dotStr}
                </span>
            </p>
        );
    }

    return (
        <span style={{ display: 'inline-block', minWidth: minLength }}>
            {_dotStr}
        </span>
    );
};
